import type { PreloadedState } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import { settings } from '@/_config';

import onDemandTutoring from './apis/answer-on-demand';
import bookingsApis from './apis/bookings-endpoints';
import bridgePlanApis from './apis/bridge-plan';
import checkoutApis from './apis/checkout-apis';
import customerApis from './apis/customer';
import customerPersistentApi from './apis/customer-persistent-api';
import unAuthCustomerApis from './apis/unauth-customer';
import rtkQueryErrorLogger from './helper/error-handling';
import reducerWithPersistance from './persist';
import type { RootState } from './reducers';

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: reducerWithPersistance,
    devTools: !settings.isProduction,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .concat(customerApis.middleware)
        .concat(onDemandTutoring.middleware)
        .concat(bridgePlanApis.middleware)
        .concat(checkoutApis.middleware)
        .concat(bookingsApis.middleware)
        .concat(unAuthCustomerApis.middleware)
        .concat(customerPersistentApi.middleware)
        .concat(rtkQueryErrorLogger),
    preloadedState,
  });

const store = setupStore();

export default store;
